export function getPianoHingeSegments(length: number): number {
  return Math.floor((length - 44) / 25.4);
}
